import {NzMessageService, NzModalService, UploadFile} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {HttpCommonService} from "../services/http-common.service";

@Injectable()
export class Upload {

  // 后台地址
  public actionUrl: string;

  // 文件列表(双向绑定)
  public fileList = [];

  // 上传列表的内建样式，支持三种基本样式 text, picture 和 picture-card (图片可以用picture,其他附件用text)
  public fileListType: string = 'picture-card';

  // 文件类型
  public fileType: string[] = ['image/png', 'image/jpeg', 'image/bmp'];

  //文件类型说明
  public fileTypeInfo: string[] = ['png', 'jpg', 'bmp'];

  // 单次是否支持选择多个附件
  public multiple: boolean = false;

  // 最多上传数
  public fileNumber: number = 1;

  // 上传文件大小(M)
  public maxSize: number = 10;

  // 图片预览地址
  public previewImageUrl: string = '';

  // 图片预览弹出框是否可见
  public previewVisible: boolean = false;

  // 是否显示上传按钮
  public showButton: boolean = false;

  // 上传状态
  public uploadStatus:any;

  constructor(public httpService: HttpCommonService, public ngModalService: NzModalService, public showMsg: NzMessageService) {
    this.actionUrl = "/zuul/" + this.httpService.getBaseUrl() + '/user/center/common/file/ajaxUpload';
  }

  // 获取后台地址
  getTempUrl() {
    return this.actionUrl;
  }

  setTempUrl(url: string) {
    this.actionUrl = this.httpService.getBaseUrl() + url;
  }

  // 检验附件类型和上传大小
  checkTypeAndSize(file: File) {
    // const isRightType = this.fileType.include(file.type);
    let isRightType = false;
    this.fileType.forEach(item =>{
      if (item == file.type) {
        isRightType =  true;
      }
    });
    const isLt2M = file.size / 1024 / 1024 < this.maxSize;
    if (isRightType == false  && false == isLt2M) {
      this.ngModalService.error({
        title: '错误',
        content: '请上传'+this.fileTypeInfo.join(",")+'格式的文件'
      });
      return false;
    }

    if (!isLt2M) {
      this.ngModalService.error({
        title: '错误',
        content: '文件大小不能超过'+this.maxSize+'M'
      });
      return false;
    }

    if (!isRightType) {
      this.ngModalService.error({
        title: '错误',
        content: '请上传'+this.fileTypeInfo.join(",")+'格式的文件'
      });
    }

    return isRightType;
  }

  // 过滤出成功上传的文件
  filterSuccessFiles(tempFiles): File[] {
      return tempFiles.filter(item => {
      // console.log(item)
      if (item.response) {
        // 过滤出成功上传的附件
        return item.response.success.length > 0;
      } else {
        return false;
      }
    });
  }

  // 处理预览图片
  handlePreview(file: UploadFile) {
    console.log(file)
    this.previewImageUrl = file.url || file.thumbUrl;
    this.previewVisible = true;
  }

  changeState(e) {
    this.uploadStatus = e.file.status;
    if (this.uploadStatus == 'done') {
      if (e.file.response.fail.length > 0) {
        let failFile = e.file.response.fail[0];
        this.showMsg.error(failFile.msg);
        let delIndex = 0;
        for (let i = 0;i < this.fileList.length;i++) {
          if (this.fileList[i].uid == e.file.uid) {
            delIndex = i;
            break;
          }
        }
        this.fileList.splice(delIndex, 1);
        return;
      }
    } else if (this.uploadStatus == 'error') {
      this.ngModalService.error({
        title: '错误',
        content: '网络不畅上传失败，请重新上传'
      });
      return;
    }
  }

  changeState2(e, upload) {
    if (e.file.status == 'done') {
      if (e.file.response.fail.length > 0) {
        let failFile = e.file.response.fail[0];
        this.showMsg.error(failFile.msg);
        let delIndex = 0;
        for (let i = 0;i < upload.fileList.length;i++) {
          if (upload.fileList[i].uid == e.file.uid) {
            delIndex = i;
            break;
          }
        }
        upload.fileList.splice(delIndex, 1);
        return;
      }
    } else if (this.uploadStatus == 'error') {
      this.ngModalService.error({
        title: '错误',
        content: '网络不畅上传失败，请重新上传'
      });
      return;
    }
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/models/upload.ts